import { useTheme } from '../../hooks/useTheme'
import { Badge } from './Badge'
import { getSectionCardStyle } from '../../utils/themeStyles'

interface ExperimentalTextImportOptionProps {
  title: string
  description: string
  onClick: () => void
  className?: string
}

export function ExperimentalTextImportOption({
  title,
  description,
  onClick,
  className = '',
}: ExperimentalTextImportOptionProps) {
  const theme = useTheme()

  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full text-left rounded-xl p-4 transition-all active:opacity-75 ${className}`}
      style={getSectionCardStyle(theme)}
    >
      <div className="flex items-center gap-2 flex-wrap mb-1.5">
        <span className="text-sm font-medium" style={{ color: theme.text.primary }}>
          {title}
        </span>
        <Badge variant="warning" size="sm">
          Experimental
        </Badge>
      </div>
      <p className="text-xs leading-relaxed" style={{ color: theme.text.muted }}>
        {description}
      </p>
    </button>
  )
}
